export default __webpack_public_path__ + "static/Entenda0096-9ec40b31efcc2e62643f68a44fa8a38a.jpg";